import styled from '@emotion/styled';
import React from 'react';

import { getSize, getColorValue } from '../../utilities';

const IllustrationWrapper = styled.span<IllustrationWrapperProps>`
  display: block;
  color: ${props =>
    props.color ? getColorValue(props.color) : getColorValue('grey8')};
  ${props => props.size && getSize('width', props.size)};
  ${props => props.size && getSize('height', props.size)};

  svg {
    display: block;
    width: 100%;
    height: 100%;
  }
`;

const Illustration = ({
  altText,
  illustration,
  src,
  color = 'orange',
  size = 12,
  ...props
}: IllustrationProps & React.ComponentProps<typeof IllustrationWrapper>) => {
  return (
    <IllustrationWrapper
      aria-hidden="true"
      aria-label={altText}
      color={color}
      size={size}
      {...props}
    >
      {src || illustration}
    </IllustrationWrapper>
  );
};

type IllustrationProps = {
  altText?: string;
  src?: React.ReactNode;
  size?: number | string;
  /** @deprecated Not applicable to Atlassian Design System Illustrations */
  color?: string;
  /** @deprecated Use src instead */
  illustration?: React.ReactNode;
};

type IllustrationWrapperProps = {
  color?: string;
  size?: number | string;
};

export default Illustration;
